<template>
  <div id="app">
    <router-view v-wechat-title='$route.meta.title+title'></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      title:' 物流唐山-唐山物流行业综合服务平台'
    }
  },
  mounted:function(){
     if(!this.getCookie('islogin')){
   //清除
     this.$store.dispatch("delete_user")
  }
  },
  methods:{
     getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';'); //把cookie分割成组    
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i]; //取得字符串    
      while (c.charAt(0) == ' ') { //判断一下字符串有没有前导空格    
        c = c.substring(1, c.length); //有的话，从第二位开始取    
      }
      if (c.indexOf(nameEQ) == 0) { //如果含有我们要的name    
        return unescape(c.substring(nameEQ.length, c.length)); //解码并截取我们要值    
      }
    }
    return false;
  }

  }
}
</script>

<style>
#app{
  min-width: 1200px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue